export default __webpack_public_path__ + "static/media/5.deafdb83.svg";